export default __webpack_public_path__ + "static/media/loading-wave-bg.804af87c.svg";